import {MixModel, ProjectDataIndex} from '../../api/types.ts';
import React, {useEffect, useRef, useState} from 'react';
import {applySplit, disposeSplit} from '../../lib/apply_split.js';
import emptyGuid from '../../lib/emptyGuid.ts';
import SceneTools from './SceneTools.tsx';
import SceneFrame, {SceneFrameHandle} from './frame/SceneFrame.tsx';
import useFillViewportHeight from '../../hooks/useFillViewportHeight.ts';

interface SceneComponentProps {
    project: MixModel;
    dataIndex: ProjectDataIndex;
    readOnly: boolean;
}

const SceneComponent: React.FC<SceneComponentProps> = ({
    project,
    dataIndex,
    readOnly
}) => {
    const {id} = project;
    const projectId = id!;
    const [syncToken, setSyncToken] = useState<string>(emptyGuid);
    const {ref: splitRef, height: fillHeight} = useFillViewportHeight(3);
    const frameRef = useRef<SceneFrameHandle>(null);
    const splitInstanceId = 'MixSceneSplit';

    useEffect(() => {
        !readOnly &&
            applySplit(splitInstanceId, ['#MixSceneTools', '#MixScene'], {
                sizes: [25, 75]
            });

        return () => {
            !readOnly && disposeSplit(splitInstanceId);
        };
    }, []);

    if (readOnly) {
        return (
            <div className="mixcode-code" id="MixScene">
                <SceneFrame
                    ref={frameRef}
                    id="MixSceneIframe"
                    style={{width: '100%', height: '100%', minHeight: '800px'}}
                    projectId={projectId}
                    dataIndex={dataIndex}
                    syncToken={syncToken}
                    tabIndex={0}
                />
            </div>
        );
    }

    return (
        <div
            ref={splitRef}
            className="split overflow-hidden"
            style={{
                height: fillHeight === null ? '100vh' : `${fillHeight}px`
            }}
        >
            <div className="mixcode-tools" id="MixSceneTools">
                <SceneTools
                    project={project}
                    dataIndex={dataIndex}
                    setSyncToken={setSyncToken}
                    frameRef={frameRef}
                />
            </div>
            <div className="mixcode-code" id="MixScene">
                <SceneFrame
                    ref={frameRef}
                    id="MixSceneIframe"
                    style={{width: '100%', height: '100%', minHeight: '800px'}}
                    projectId={projectId}
                    dataIndex={dataIndex}
                    syncToken={syncToken}
                />
            </div>
        </div>
    );
};

export default SceneComponent;
